import { log } from "../../../util/log";
import { getErrorMessageOrDefault } from "@vortex/shared";
function hasLoop(categories, category) {
    const visited = [];
    let iter = category;
    while (iter !== undefined && categories[iter] !== undefined) {
        if (visited.includes(iter)) {
            return true;
        }
        visited.push(iter);
        iter = categories[iter].parentCategory;
    }
    return false;
}
function fixLoops(dict) {
    Object.keys(dict).forEach((key) => {
        if (hasLoop(dict, key)) {
            dict[key].parentCategory = undefined;
        }
    });
}
/**
 * retrieve the categories by the server call
 *
 * @param {string} activeGameId
 * @param {NexusT} nexus
 * @return {ICategoryDictionary} res
 *
 */
function retrieveCategoryList(activeGameId, nexus) {
    return new Promise((resolve, reject) => {
        nexus
            .getGameInfo(activeGameId)
            .then((gameInfo) => {
            if (gameInfo.categories !== undefined) {
                const res = {};
                let counter = 1;
                gameInfo.categories.forEach((category) => {
                    const parent = category.parent_category === false
                        ? undefined
                        : category.parent_category.toString();
                    res[category.category_id.toString()] = {
                        name: category.name,
                        parentCategory: parent,
                        order: counter,
                    };
                    ++counter;
                });
                fixLoops(res);
                return resolve(res);
            }
        })
            .catch((err) => {
            log("error", "Failed to retrieve game information", {
                err: getErrorMessageOrDefault(err),
            });
            reject(err);
        });
    });
}
export default retrieveCategoryList;
